export const state = () => ({
    jobs: [],
    page: 0,
});
